let cookie = {
  //设置cookie
  setCookie(c_name, value, expire) {
    var date = new Date();
    date.setTime(date.getTime() + 24 * 60 * 60 * 1000 * expire);
    document.cookie = c_name + "=" + escape(value) + "; expires=" + date.toGMTString();
  },
  //读取cookie
  getCookie(cookieName) {
    if (document.cookie.length > 0) {
        var strCookie = document.cookie;
        var arrCookie = strCookie.split("; ");
        for(var i = 0; i < arrCookie.length; i++){
            var arr = arrCookie[i].split("=");
            if(cookieName == arr[0]){
                return arr[1];
            }
        }
        return "";
    }

  },
  //清除cookie
  clearCookie: function (name) {
    this.setCookie(name, "", -1);//修改2值都为空，天数为负1
  },

};
export default cookie
